import { Module } from 'vuex';

import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';
import { RootState } from '@/store/types';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { ActivityTypesRoughState } from './types';

export function initialState(): ActivityTypesRoughState {
  return {
    ...initialStateSubscribable(),
  };
}

const activityTypesRoughModule: Module<ActivityTypesRoughState, RootState> = {
  namespaced: true,
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default activityTypesRoughModule;
